import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import config from 'config';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export interface UserData {
  password: string;
  password_confirmation: string;
  token: string;
}
export interface CreateUserMutationArguments {
  token: string;
  userData: UserData;
}

async function updateUserPassword(token: string, userData: UserData): Promise<UserData> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/invite/set-password`, {
    ...userData,
    token,
  });
  return data;
}

export default function useUpdateUserPasswordMutation() {
  const navigate = useNavigate();
  const toast = useToast();
  const mutation = useMutation({
    mutationFn: ({ token, userData }: CreateUserMutationArguments) => updateUserPassword(token, userData),
    onSuccess: () => {
      navigate('/app');
    },
  });

  useEffect(() => {
    if (mutation.isError) {
      const customTitle = 'forms:password.invalid_token.message';
      manageErrorResponse(toast, mutation.error as any, customTitle);
    }
  }, [mutation.isError, mutation.error, toast]);

  return mutation;
}
